export const environment = {
  customemailValidationRegex:
    /^[^<>()[\]\\,;:%#^\s"$&!@]+@((\[\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}\])|(([a-zA-Z0-9]+\.)+[a-zA-Z]{2,}))$/,
  customnationalIdValidationRegex: /^[1-3](19|20)\d{2}[7-8]\d{7}[0-9]\d{2}$/,
  customphoneValidationRegex: /^07[2-9][0-9]{7}$/,
  noWhiteSpaceRegex: /^\S+(?:\s+\\S+)*$/,
  passportFieldRegex: /^[a-zA-Z0-9]*$/,
  production: false,
  authServiceUrl: 'https://hub-keycloak.demo.irembolabs.com',
  authRealm: 'irembo',
  authClientId: 'agents-portal',
  authSuccessRedirectUrl: 'https://agent-portal.demo.irembolabs.com',
  apiGatewayBaseUrl: 'https://agent-gateway.demo.irembolabs.com',
  IREMBOPAY_CDN:
    'https://dashboard.sandbox.irembopay.com/assets/payment/inline.js',
  IREMBOPAY_TEST: true,
  locale: 'IremboPay.locale.EN',
  anonymousCitizenId: '6824f8f4-a66f-46c6-b022-fedc884251c9',
  applicationByOther: true,
  iremboPrivacyPolicyUrl: 'https://irembo.gov.rw/support/legal-information',
  allowUploadPreviousFiles: false,
  DEFAULT_LOCALE: 'en-US',
  DEFAULT_LOCALE_NAME: 'English',
  NIDA_GET_ID_INFO_ENDPOINT_CODE: 'NIDAGETIDINFO',
  translationSourceUrl: 'https://agent-gateway.demo.irembolabs.com',
  knowledgeBaseUrl: 'https://irembohub.freshdesk.com/en/support/home',
  systemStatusUrl: 'https://status.irembo.gov.rw/',
  endpointCodes: {
    companyTin: 'FTINDETAILS',
  },
  AESEncryptionKey: 'BBMLSmZq5g',
  isDocumentScanningEnabled: true,
  iremboGovUrl: 'https://iremboui.uat.iremboinc.com/home/citizen/all_services',
  termsOfUseUrl: 'https://new.irembo.gov.rw/legal-information',
  consentSystemCode: 'IREMBOHUB_AGENT_PORTAL',
  gov2PortalUrl: 'https://iremboui.uat.iremboinc.com',
  gov2ApiBaseUrl: 'https://iremboui.uat.iremboinc.com/irembo/rest',
  MIXPANEL_TOKEN: 'fb2a9200be250ed27bfaca86b6a0d989',
  IS_SENDING_ANALYTICS_EVENTS_ACTIVE: false,
};
